window.showOnboardingWizard = function() {
  setTimeout(function() {
    $(document.body).css('overflow', 'hidden')
    $('.mini-tour-modal-wrapper').addClass('open');
  }, 100);
}

document.addEventListener("turbolinks:load", function() {

  $(document).find('.get-tour-started').on('click', function(){
    $('.mini-tour-modal-wrapper').removeClass('open');
    var tour = new APTour();
  });

  $(document).find('.tour-complete').on('click', function(){
    $('.mini-tour-modal-wrapper').removeClass('open');
    $('.mini-tour-complete-modal-wrapper').removeClass('open');
    $('.aptour-overlay').remove();
    $('.aptour-window').remove();
    window.location.reload();
    $('html, body').animate({scrollTop:0},500);
  });

  /**
  * Handle click events.
  * 
  * @function
  * @param { Object } event - The click event.
  */
  APTour.prototype.handleClicks = function(event) {
    var targetAttr = event.target.getAttribute('data-aptour-nav');

    //Only listen for button clicks.
    if (targetAttr) {
      event.preventDefault();
      switch (targetAttr) {
        case 'prev':
          if (this.cursor > 0) {
            this.tourItems[this.cursor].classList.remove('aptour-active');
            this.moveTo(--this.cursor);
          }
          break;
        case 'next':
          if (this.cursor < this.stops.length - 1) {
            this.tourItems[this.cursor].classList.remove('aptour-active');
            this.moveTo(++this.cursor);
          } 
          else if (this.cursor == this.tourItems.length-1) {
            this.tourItems[this.cursor].classList.remove('aptour-active');
            const elements = document.getElementsByClassName("aptour-overlay");
            while (elements.length > 0) elements[0].remove();
            const elements1 = document.getElementsByClassName("aptour-window");
            while (elements1.length > 0) elements1[0].remove(); 
            document.getElementById('mini_tour_complete_modal').classList.add('open'); 
            this.cursor = 0;
          }
          break;
        case 'close':
          // Delete the window.
          document.body.removeChild(this.overlay);
          document.body.removeChild(this.tourWindow);
          break;
      }
    }
  }

  /**
  * Shows a specific stop.
  * 
  * @function
  * @param { Number } index - The position of the stop we need to show.
  */
  APTour.prototype.moveTo = function(index) {
    var parent = this.tourItems[index],
    parentSpecs = parent.getBoundingClientRect(),
    bodySpecs = document.body.getBoundingClientRect(),
    position = this.stops[index].position,
    left, top, scrollPosition;

    // If the css position is not set, set to relative.
    if (parent.style.position === '') {
      parent.style.position = 'relative'
    }

    // Add the active class.
    parent.classList.add('aptour-active');
    this.tourWindow.removeAttribute("id", 'adjust-box-shadow');
    if (index >= 6) {
      parent.classList.add('adjust-aptour-active');
    }
    if (this.tourItems.length == 8 && index == 6) {
      this.tourWindow.setAttribute("id", 'adjust-box-shadow');
    }
    this.tourWindow.classList.add('arrow');
    if (index == 0) {
      parent.setAttribute("id", "adjust-height-0");
      this.tourWindow.querySelector('.prev-link').style.visibility = 'hidden';
    }
    else {
      this.tourWindow.querySelector('.prev-link').style.visibility = 'initial';
    }
    
    //Set the tour window contents.
    this.tourWindow.querySelector('.aptour-window-desc').innerHTML = this.stops[index].desc;
    this.tourWindow.querySelector('.page').textContent = (this.cursor+1)+'/'+(this.tourItems.length)
    
    if ($(window).width() < 1024) {
      position = 'top';
    }
    //set the tour window coordinates.
    switch(position) {
      case 'top':
        // Center H.
        this.tourWindow.classList.add('top');
        left = parentSpecs.left + ((parent.offsetWidth - this.tourWindow.offsetWidth) / 2);
        top = parentSpecs.top - this.tourWindow.offsetHeight - this.offset - bodySpecs.top;
        scrollPosition = parentSpecs.top - bodySpecs.top - this.tourWindow.offsetHeight - this.offset;
        break;
      case 'right':
        this.tourWindow.classList.add('right');
        left = parentSpecs.right + this.offset;
        //center V.
        top = (((parentSpecs.top + parentSpecs.bottom) / 2) - (this.tourWindow.offsetHeight / 2) - bodySpecs.top);
        scrollPosition = parentSpecs.top - bodySpecs.top;
        break;
      case 'bottom':
        // Center H.
        this.tourWindow.classList.remove('top');
        this.tourWindow.classList.add('bottom');
        left = parentSpecs.left + ((parent.offsetWidth - this.tourWindow.offsetWidth) / 2);
        top = parentSpecs.bottom  + this.offset - bodySpecs.top;
        scrollPosition = parentSpecs.top - bodySpecs.top;
        break;
      case 'left':
        this.tourWindow.classList.remove('right');
        this.tourWindow.classList.add('left');
        left = parentSpecs.left - this.offset - this.tourWindow.offsetWidth;
        //center v.
        top = (parentSpecs.top + parentSpecs.bottom) / 2 - this.tourWindow.offsetHeight / 2 - bodySpecs.top;
        scrollPosition = parentSpecs.top - bodySpecs.top;
        break;
    }

    if ($(window).width() < 540) {
      window.scrollTo(0, scrollPosition - 80);
    } 
    else {
      window.scrollTo(0, scrollPosition - 200);
    }
    this.tourWindow.style.left = left + 'px';
    this.tourWindow.style.top = top + 'px';

  };

  /**
  * Initializes the tour by creating the stops and showing the first one.
  * 
  * @function
  */
  APTour.prototype.initialize = function() {
  var tourWindowContents = "";
  // Define the stops, cursor and offset.
  this.stops = [];
  this.cursor = 0;
  this.offset = 30; // The distnace between teh window and the parent element.

  for(var i = 0; i < this.tourItems.length; i++) {
    this.stops[i] = JSON.parse(this.tourItems[i].getAttribute('data-aptour'));
  }

  //create an overlay on the entire page
  this.overlay = document.createElement('div');
  this.overlay.className = 'aptour-overlay';
  document.body.insertBefore(this.overlay, document.body.childNodes[3]);

  // Create the main tour window and create its content.
  this.tourWindow = document.createElement('div');
  this.tourWindow.className = 'aptour-window';
  tourWindowContents += '<div class="aptour-window-desc"></div>';
  tourWindowContents += '<div class="onboarding-footer">';
  tourWindowContents += '<div class="page"></div>';
  tourWindowContents += '<div class="prev-link" data-aptour-nav="prev">Previous</div>';
  tourWindowContents += '<button data-aptour-nav="next">Next</button>';
  tourWindowContents += '</div>';
  this.tourWindow.innerHTML = tourWindowContents;
  document.body.insertBefore(this.tourWindow, document.body.childNodes[0]);

  this.moveTo(this.cursor);
  };


  /**
  * Defines the main constructor function 
  * 
  * @constructor
  */
  function APTour() {
    // Get tour itmes.
    this.tourItems = document.querySelectorAll('[data-aptour]');

    // If there are no tour itmes, log an error and return.
    if (this.tourItems.length === 0) {
      if (console) {
        console.log('Sorry, we couldn\'t find any valid tour items.')
      }
      return;
    }

    //Handle navigation button clicks.
    document.body.addEventListener('click', this.handleClicks.bind(this));

    // Initializr the tour.
    this.initialize();
  }
});
